import type { FC } from 'react';
import { Translation } from 'utils/translations';

import { type Item, ItemType } from './types';

const namesMap: Partial<Record<ItemType, string>> = {
  [ItemType.favorites]: 'favorites',
  [ItemType.all]: 'all_games',
  [ItemType.live]: 'all_games',
};

const ListLabel: FC<{ activeItem: Item }> = ({ activeItem }) => {
  const { icon, type, name } = activeItem;
  const translationKey = namesMap[type];

  return (
    <>
      {icon} {translationKey ? <Translation message={translationKey} /> : name}
    </>
  );
};

export default ListLabel;
